// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2b33l","label":"CategoryService_label__3ECa_","location":"CategoryService_location__2vQUt"};